import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StockMaintenanceService {

  constructor(private http: HttpClient) { }

  /**
   * Query stock data
   *
   * @param request Query parameter
   * @returns
   */
   queryStockData(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/queryStockData`;
    return this.http.post(url, request);
  }

  /**
   * Export stock data
   *
   * @param request Query parameter
   * @returns
   */
  exportStockData(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/exportStockData`;
    return this.http.post(url, request);
  }

  /**
   * Import Tracking Item
   *
   * @param file upload file
   * @param createUser create User
   */
  importTrackingItemExcelBy(file: any, facility: any, createUser: any): Observable<any> {

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('facility', facility);
    formData.append('createUser', createUser);

    const url = `${environment.expenseApiUrl}/import/trackingItemExcelBy`;
    return this.http.post(url, formData);
  }

  /**
   * Save Tracking Item
   *
   * @param request Tracking item array
   * @returns
   */
  saveTrackingItem(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/saveTrackingItem`;
    return this.http.post(url, request);
  }

  searchSKU(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/searchSKU`;
    return this.http.post(url, request);
  }

  searchStockInfoByUid(params: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/searchStockInfoByUid`;
    return this.http.post(url, params);
  }

  searchStockInfo(params: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/searchStockInfo`;
    return this.http.post(url, params);
  }

  exportStockInfoExcel(params: any,language: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/stockMaintain/exportStockInfoExcel/${language}`;
    return this.http.post(url, params, { responseType: 'blob' });
  }
}
